import React, { lazy } from 'react';
import { Route } from 'react-router';
import Authenticated from '../../components/auth/Authenticated';
import routes from '../routes';

const BibleQuoteListScreen = lazy(() => import('../../screens/BibleQuote/screens/List'));
const BibleQuoteViewScreen = lazy(() => import('../../screens/BibleQuote/screens/View'));
const BibleQuoteCreateScreen = lazy(() => import('../../screens/BibleQuote/screens/Create'));
const BibleQuoteEditScreen = lazy(() => import('../../screens/BibleQuote/screens/Edit'));

const bibleQuoteRoutes = [
    <Route
        exact
        key={routes.BIBLE_QUOTE_LIST}
        path={routes.BIBLE_QUOTE_LIST}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <BibleQuoteListScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.BIBLE_QUOTE_VIEW}
        path={routes.BIBLE_QUOTE_VIEW}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <BibleQuoteViewScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.BIBLE_QUOTE_CREATE}
        path={routes.BIBLE_QUOTE_CREATE}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <BibleQuoteCreateScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.BIBLE_QUOTE_EDIT}
        path={routes.BIBLE_QUOTE_EDIT}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <BibleQuoteEditScreen />
            </Authenticated>
        )}
    />,
];

export default bibleQuoteRoutes;
